import { Button, SxProps, Theme } from "@mui/material";

import React from "react";
import { useNavigate } from "react-router-dom";

const VButton = ({ text, type = "primary", sx, fullWidth = true, onClick, navigate, disabled }: Props) => {
  const dispatch = useNavigate();

  const navigateFunction = () => {
    dispatch(navigate as string);
  };

  return (
    <Button
      sx={[
        style.common,

        type === "primary" && {
          ...style.primaryStyle,
        },
        type === "outlined" && {
          ...style.outlinedStyle,
        },
        type === "alert" && {
          ...style.alertStyle,
        },

        fullWidth && {
          width: "100%",
        },

        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      onClick={navigate ? navigateFunction : onClick}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

type Props = {
  text?: string;
  type?: "primary" | "outlined" | "alert";
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  navigate?: string;
  disabled?: boolean;
};

const style = {
  common: {
    letterSpacing: ".05rem",
    fontWeight: "600",
    fontSize: "medium",
    borderRadius: "20px",
    border: "3px solid #2D4561",
    paddingTop: "1em",
    paddingBottom: "1em",
    "&:disabled": {
      borderColor: "rgba(0, 0, 0, 0.26)",
    },
  },

  primaryStyle: {
    ":hover": {
      backgroundColor: "#355273",
    },
    color: "white",
    backgroundColor: "#2D4561",
  },

  outlinedStyle: {
    color: "#2D4561",
    backgroundColor: "white",
  },

  alertStyle: {
    ":hover": {
      backgroundColor: "#fdf7f7",
    },
    borderColor: "#D32F2F",
    color: "#d32f2f",
    backgroundColor: "white",
  },
};

export default VButton;
